import React from 'react';
import {patientContacts} from '../services/patientOperations';
import './PatientOperations.css';
export function PatientContactActions({patient}) {
 const contacts=patientContacts(patient);
 return <div className="patient-contact-actions clinic-action-row" aria-label={`Contatta ${patient.firstName} ${patient.lastName}`}>
  {contacts.call&&<a className="clinic-action-link" href={contacts.call}>Chiama</a>}
  {contacts.whatsapp&&<a className="clinic-action-link" href={contacts.whatsapp} target="_blank" rel="noreferrer">WhatsApp</a>}
  {contacts.email&&<a className="clinic-action-link" href={contacts.email}>Email</a>}
  {!contacts.call&&!contacts.email&&<span>Nessun recapito utilizzabile</span>}
  {contacts.call&&!contacts.whatsapp&&<small>Per WhatsApp aggiungi il prefisso internazionale al telefono.</small>}
 </div>;
}
